function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.29 10.764A2 2 0 016.276 9h19.448a2 2 0 011.986 1.764l2.024 17A2 2 0 0127.748 30H4.252a2 2 0 01-1.986-2.236l2.024-17z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.85 6A4.15 4.15 0 0113 1.85h6A4.15 4.15 0 0123.15 6v3h-2.3V6A1.85 1.85 0 0019 4.15h-6A1.85 1.85 0 0011.15 6v3h-2.3V6z",
  fill: "url(#purchases_svg__paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "purchases_svg__paint0_linear",
  x1: 11.531,
  y1: 1.85,
  x2: 21.241,
  y2: 6.291,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})));

var SvgPurchases = function SvgPurchases(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default SvgPurchases;